import React, { useState } from 'react'
import { Modal, Button, Spin, Input } from 'antd'
import { updateStatusBatchV2, listItemBatches } from '../../../../../services/api/3dApi'
import SelectPartnerSewing from '../../../../update-batches/components/SelectPartnerSewing'
import Promise from "bluebird"

const ActionChangeSewing = ({ isOpen, closeModal, selectedItems, refreshBatches, toggleSelectAll, batches }) => {
    const [partner, setPartner] = useState('')
    const [giveSewName, setGiveSewName] = useState('')
    const [loading, setLoading] = useState(false)
    const [isChange, setIsChange] = useState(false)
    const [itemsSuccess, setItemsSuccess] = useState([])
    const [itemError, setItemError] = useState([])

    const listBatches = batches.filter(batch => selectedItems.includes(batch._id))

    const _checkStatusDetailBatch = async (id) => {
        try {
            const rqUrl = `limit=1000&page=1`
            const { data: response } = await listItemBatches(id, rqUrl)
            const { data, success, error } = response

            if (!success) {
                throw new Error(error)
            }

            const { items } = data
            const results = items.every(item => item.status === "wait_to_sew" || item.status === "moved" || item.status === "confirmed" || !!item.error_at)

            return results

        } catch (e) {
            throw new Error(e.message)
        }
    }

    const onChangeStatus = async () => {
        setLoading(true)
        setIsChange(true)

        await Promise.each(selectedItems, async item => {

            const itemBatch = batches.find(batch => batch._id === item)

            if (itemBatch.status !== "wait_to_sew") {
                itemError.push({
                    _id: item,
                    message: `Có lỗi trong quá trình xử lý: Lô đã đang ở trạng thái '${itemBatch.status}'`
                })
                setItemError([...itemError])
                setLoading(false)
            } else {
                const validateChangeStatus = await _checkStatusDetailBatch(item)
                if (!validateChangeStatus) {
                    itemError.push({
                        _id: item,
                        message: "Item trong lô đang không thuộc 1 trong các trạng thái sau: 'wait_to_sew', 'confirmed', 'moved' hoặc được đánh dấu lỗi"
                    })
                    setItemError([...itemError])
                    setLoading(false)
                } else {
                    try {
                        const payload = {
                            partner: partner,
                            batchIds: [item],
                            status: "sewing",
                            give_sew_name: giveSewName,
                        }
                        const { data: response } = await updateStatusBatchV2(payload)
                        const { success, error } = response

                        if (!success) {
                            setLoading(false)
                            itemError.push({
                                _id: item,
                                message: error
                            })
                            setItemError([...itemError])
                        } else {
                            itemsSuccess.push(item)
                            setItemsSuccess([...itemsSuccess])
                        }

                    } catch (e) {
                        setLoading(false)
                        throw Error(e.message)

                    } finally {
                        setLoading(false)
                    }
                }
            }
        })
    }

    const _showMessage = (itemError, itemsSuccess, _id) => {
        if (itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if (itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">
                        {itemError.find(itemErr => _id === itemErr._id).message}
                    </span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if (itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Chuyển trạng thái đang may thành công!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    const _hanldeClose = () => {
        closeModal()
        toggleSelectAll(false)
        refreshBatches()
    }

    const onChangeSelect = (value) => {
        setPartner(value)
    }
    const handleChangeInput = (e) => {
        const {name, value} = e.target
        setGiveSewName(value)
    }

    return (
        <Modal
            title="Chuyển lô đang may"
            visible={isOpen}
            className={'CustomModal'}
            width={950}
            onOk={onChangeStatus}
            onCancel={closeModal}
            footer={[
                <Button key="back" onClick={closeModal} className={!isChange ? "" : "d-none"}>
                    Hủy
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={onChangeStatus}
                    className={!isChange ? "" : "d-none"}
                >
                    Chuyển trạng thái
                </Button>,
                <Button onClick={_hanldeClose} className={`bg-grey ml-2 ${isChange ? "" : "d-none"}`}>
                    Đóng
                </Button>
            ]}
        >
            {!isChange ?
                <>
                    <div className='d-flex align-items-center justify-content-between'>
                        <SelectPartnerSewing
                            partner={partner} onChangePartner={onChangeSelect}
                        />
                        <div className='Human mb-3'>
                            <label className='d-block'>Người giao may (<span className='text-danger'>* bắt buộc</span>)</label>
                            <Input
                                value={giveSewName}
                                size='large'
                                name='giveSewName'
                                placeholder={'Người giao may'}
                                onChange={handleChangeInput}
                            />
                        </div>
                    </div>
                    {!!partner && !!giveSewName &&
                        <p>Bạn có chắc chắn muốn chuyển trạng thái <b>đang may(sewing)</b> cho <b>{selectedItems.length || 0}</b> lô được chọn không?</p>
                    }
                </>
                : (
                    <div className="ListChangeStatusBatch">
                        {listBatches.length > 0 && (
                            listBatches.map(item => {
                                return (
                                    <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                                        <div className="IconStatus mr-2 d-flex align-items-end">
                                            {itemsSuccess.includes(item._id) && (
                                                <Button icon="check" className='icon-check text-success'></Button>
                                            )}
                                            {
                                                (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) && (
                                                    <Button icon="cross" className='icon-cross text-danger'></Button>
                                                )
                                            }
                                        </div>
                                        <div className="ContentGenLabel">
                                            <strong className='mr-2'>{item.name}</strong>
                                            {loading && <Spin />}
                                            {_showMessage(itemError, itemsSuccess, item._id)}
                                        </div>
                                    </div>
                                )
                            })
                        )}
                    </div>
                )
            }
        </Modal>
    )
}

export default ActionChangeSewing